import * as _ from 'lodash';

export class ConfigurationCategory {
    private _categoryElement: JQuery;
    private _arrow: JQuery;

    public constructor(htmlItem: HTMLElement) {
        this.onShow = this.onShow.bind(this);
        this.onHide = this.onHide.bind(this);
        this._categoryElement = jQuery(htmlItem);
        this._arrow = $("#" + htmlItem.id + "_arrow");
        this._categoryElement.on("show.bs.collapse", this.onShow);
        this._categoryElement.on("hide.bs.collapse", this.onHide);
    }

    public show() {
        this._categoryElement["collapse"]("show");
    }

    public hide() {
        this._categoryElement["collapse"]("hide");
    }

    private onShow() {
        this._arrow.addClass("fa-caret-down");
        this._arrow.removeClass("fa-caret-right");
    }

    private onHide() {
        this._arrow.removeClass("fa-caret-down");
        this._arrow.addClass("fa-caret-right");
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Components/ConfigurationPanel/ConfigurationCategory.ts
 **/